const ouhai = {
  crowdData: [
    {
      title: '污水收集井',
      total: 1146,
      add: 1,
    },
    {
      title: '雨水收集井',
      total: 1009.5,
      add: 2,
    },
    {
      title: '污水检查井',
      total: 1047,
      add: 2,
    },
    {
      title: '雨水检查井',
      total: 1009.5,
      add: 1,
    },
    {
      title: '污水立管',
      total: 1658,
      add: 0,
    },
    {
      title: '雨水立管',
      total: 660,
      add: 3,
    },
    {
      title: '化粪池',
      total: 840,
      add: 1,
    },
    {
      title: '隔油池',
      total: 315,
      add: 0,
    },
  ],
  warnData: [500, 150, 80],
  sexData: [
    {
      name: '雨水',
      count: 335,
    },
    {
      name: '污水',
      count: 310,
    },
  ],
  ageData: [
    { name: '1月', value: 300 },
    { name: '2月', value: 350 },
    { name: '3月', value: 400 },
    { name: '4月', value: 400 },
    { name: '5月', value: 430 },
    { name: '6月', value: 450 },
    { name: '7月', value: 400 },
  ],
  taskData:[
    ['浙江省温州市瓯海区南白象街道','已完成'],
    ['浙江省温州市瓯海区娄桥街道','已完成'],
    ['浙江省温州市瓯海区娄桥街道','已完成'],
    ['浙江省温州市瓯海区郭溪街道','已完成'],
    ['浙江省温州市瓯海区瞿溪街道','已完成'],
    ['浙江省温州市瓯海区娄桥街道','已完成'],
    ['浙江省温州市瓯海区娄桥街道','已完成'],
    ['浙江省温州市瓯海区南白象街道','已完成'],
    ['浙江省温州市瓯海区娄桥街道','已完成'],
    ['浙江省温州市瓯海区郭溪街道','已完成'],
    ['浙江省温州市瓯海区瞿溪街道','已完成'],
    ['浙江省温州市瓯海区娄桥街道','已完成'],
    ['浙江省温州市瓯海区娄桥街道','已完成']
  ]
}
const jingshan = {
  crowdData: [
    {
      title: '污水收集井',
      total: 76,
      add: 2,
    },
    {
      title: '雨水收集井',
      total: 73,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 74,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 73,
      add: 0,
    },
    {
      title: '污水立管',
      total: 100,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 54,
      add: 1,
    },
    {
      title: '化粪池',
      total: 60,
      add: 2,
    },
    {
      title: '隔油池',
      total: 31,
      add: 0,
    },
  ],
  warnData: [230, 60, 20],
  sexData: [
    {
      name: '雨水',
      count: 335,
    },
    {
      name: '污水',
      count: 310,
    },
  ],
  ageData: [
  { name: '1月', value: 30 },
  { name: '2月', value: 35 },
  { name: '3月', value: 40 },
  { name: '4月', value: 40 },
  { name: '5月', value: 43 },
  { name: '6月', value: 45 },
  { name: '7月', value: 40 },
  ],
}
const wutian = {
  crowdData: [
    {
      title: '污水收集井',
      total: 95,
      add: 2,
    },
    {
      title: '雨水收集井',
      total: 84,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 85,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 84,
      add: 0,
    },
    {
      title: '污水立管',
      total: 124,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 64,
      add: 1,
    },
    {
      title: '化粪池',
      total: 68,
      add: 2,
    },
    {
      title: '隔油池',
      total: 24,
      add: 0,
    },
  ],
  warnData: [210, 40, 30],
  sexData: [
    {
      name: '雨水',
      count: 335,
    },
    {
      name: '污水',
      count: 310,
    },
  ],
  ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
  ],
}
const nbx = {
  crowdData: [
    {
      title: '污水收集井',
      total: 171,
      add: 2,
    },
    {
      title: '雨水收集井',
      total: 112,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 74,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 112,
      add: 0,
    },
    {
      title: '污水立管',
      total: 143,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 78,
      add: 1,
    },
    {
      title: '化粪池',
      total: 64,
      add: 2,
    },
    {
      title: '隔油池',
      total: 18,
      add: 0,
    },
  ],
  warnData: [240, 50, 40],
 sexData: [
   {
     name: '雨水',
     count: 335,
   },
   {
     name: '污水',
     count: 310,
   },
 ],
 ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
 ],
}
const chashan = {
  crowdData: [
    {
      title: '污水收集井',
      total: 83,
      add: 3,
    },
    {
      title: '雨水收集井',
      total: 65,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 65,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 65,
      add: 0,
    },
    {
      title: '污水立管',
      total: 132,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 36,
      add: 1,
    },
    {
      title: '化粪池',
      total: 52,
      add: 2,
    },
    {
      title: '隔油池',
      total: 43,
      add: 0,
    },
  ],
  warnData: [240, 50, 40],
 sexData: [
   {
     name: '雨水',
     count: 335,
   },
   {
     name: '污水',
     count: 310,
   },
 ],
 ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
 ],
}
const louqiao = {
  crowdData: [
    {
      title: '污水收集井',
      total: 25,
      add: 3,
    },
    {
      title: '雨水收集井',
      total: 54,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 89,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 54,
      add: 0,
    },
    {
      title: '污水立管',
      total: 110,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 42,
      add: 1,
    },
    {
      title: '化粪池',
      total: 74,
      add: 2,
    },
    {
      title: '隔油池',
      total: 21,
      add: 0,
    },
  ],
  warnData: [220, 58, 42],
  sexData: [
    {
      name: '雨水',
      count: 335,
    },
    {
      name: '污水',
      count: 310,
    },
  ],
  ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
  ],
}
const xinqiao = {
  crowdData: [
    {
      title: '污水收集井',
      total: 56,
      add: 3,
    },
    {
      title: '雨水收集井',
      total: 64,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 74,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 64,
      add: 0,
    },
    {
      title: '污水立管',
      total: 140,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 39,
      add: 1,
    },
    {
      title: '化粪池',
      total: 53,
      add: 2,
    },
    {
      title: '隔油池',
      total: 36,
      add: 0,
    },
  ],
  warnData: [220, 58, 42],
  sexData: [
    {
      name: '雨水',
      count: 335,
    },
    {
      name: '污水',
      count: 310,
    },
  ],
  ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
  ],
}
const sanyang = {
  crowdData: [
    {
      title: '污水收集井',
      total: 32,
      add: 3,
    },
    {
      title: '雨水收集井',
      total: 50.5,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 88,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 50.5,
      add: 0,
    },
    {
      title: '污水立管',
      total: 100,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 47,
      add: 1,
    },
    {
      title: '化粪池',
      total: 54,
      add: 2,
    },
    {
      title: '隔油池',
      total: 14,
      add: 0,
    },
  ],
  warnData: [220, 58, 42],
  sexData: [
    {
      name: '雨水',
      count: 335,
    },
    {
      name: '污水',
      count: 310,
    },
  ],
  ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
  ],
}
const quxi = {
  crowdData: [
    {
      title: '污水收集井',
      total: 34,
      add: 3,
    },
    {
      title: '雨水收集井',
      total: 59.5,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 76,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 59.5,
      add: 0,
    },
    {
      title: '污水立管',
      total: 140,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 51,
      add: 1,
    },
    {
      title: '化粪池',
      total: 69,
      add: 2,
    },
    {
      title: '隔油池',
      total: 25,
      add: 0,
    },
  ],
  warnData: [220, 58, 42],
 sexData: [
   {
     name: '雨水',
     count: 335,
   },
   {
     name: '污水',
     count: 310,
   },
 ],
 ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
 ],
}
const guoxi = {
  crowdData: [
    {
      title: '污水收集井',
      total: 78,
      add: 3,
    },
    {
      title: '雨水收集井',
      total: 70,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 82,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 70,
      add: 0,
    },
    {
      title: '污水立管',
      total:135,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 56,
      add: 1,
    },
    {
      title: '化粪池',
      total: 56,
      add: 2,
    },
    {
      title: '隔油池',
      total: 35,
      add: 0,
    },
  ],
  warnData: [220, 58, 42],
 sexData: [
   {
     name: '雨水',
     count: 335,
   },
   {
     name: '污水',
     count: 310,
   },
 ],
 ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
 ],
}
const panqiao = {
  crowdData: [
    {
      title: '污水收集井',
      total: 116,
      add: 3,
    },
    {
      title: '雨水收集井',
      total: 79,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 84,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 79,
      add: 0,
    },
    {
      title: '污水立管',
      total: 145,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 66,
      add: 1,
    },
    {
      title: '化粪池',
      total: 78,
      add: 2,
    },
    {
      title: '隔油池',
      total: 1176,
      add: 13,
    },
  ],
  warnData: [220, 58, 42],
  sexData: [
    {
      name: '雨水',
      count: 335,
    },
    {
      name: '污水',
      count: 310,
    },
  ],
  ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
  ],
}
const liao = {
  crowdData: [
    {
      title: '污水收集井',
      total: 90,
      add: 3,
    },
    {
      title: '雨水收集井',
      total: 81.5,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 86,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 81.5,
      add: 0,
    },
    {
      title: '污水立管',
      total: 165,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 39,
      add: 1,
    },
    {
      title: '化粪池',
      total: 89,
      add: 2,
    },
    {
      title: '隔油池',
      total: 16,
      add: 0,
    },
  ],
  warnData: [220, 58, 42],
  sexData: [
    {
      name: '雨水',
      count: 335,
    },
    {
      name: '污水',
      count: 310,
    },
  ],
  ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
  ],
}
const xianyan = {
  crowdData: [
    {
      title: '污水收集井',
      total: 166,
      add: 3,
    },
    {
      title: '雨水收集井',
      total: 110,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 74,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 110,
      add: 0,
    },
    {
      title: '污水立管',
      total: 135,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 41,
      add: 1,
    },
    {
      title: '化粪池',
      total: 68,
      add: 2,
    },
    {
      title: '隔油池',
      total: 17,
      add: 1,
    },
  ],
  warnData: [220, 58, 42],
  sexData: [
    {
      name: '雨水',
      count: 335,
    },
    {
      name: '污水',
      count: 310,
    },
  ],
  ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
  ],
}
const zeya = {
  crowdData: [
    {
      title: '污水收集井',
      total: 124,
      add: 3,
    },
    {
      title: '雨水收集井',
      total: 107,
      add: 1,
    },
    {
      title: '污水检查井',
      total: 96,
      add: 1,
    },
    {
      title: '雨水检查井',
      total: 107,
      add: 0,
    },
    {
      title: '污水立管',
      total: 89,
      add: 1,
    },
    {
      title: '雨水立管',
      total: 47,
      add: 1,
    },
    {
      title: '化粪池',
      total: 55,
      add: 2,
    },
    {
      title: '隔油池',
      total: 22,
      add: 1,
    },
  ],
  warnData: [220, 58, 42],
  sexData: [
    {
      name: '雨水',
      count: 335,
    },
    {
      name: '污水',
      count: 310,
    },
  ],
  ageData: [
 { name: '1月', value: 30 },
 { name: '2月', value: 35 },
 { name: '3月', value: 40 },
 { name: '4月', value: 40 },
 { name: '5月', value: 43 },
 { name: '6月', value: 45 },
 { name: '7月', value: 40 },
  ],
}

const data = {
  ouhai,
  jingshan,
  wutian,
  nbx,
  chashan,
  louqiao,
  xinqiao,
  sanyang,
  quxi,
  guoxi,
  panqiao,
  liao,
  xianyan,
  zeya
}

export default data
